import { render, staticRenderFns } from "./Mymenber.vue?vue&type=template&id=523e1428&scoped=true"
import script from "./Mymenber.vue?vue&type=script&lang=js"
export * from "./Mymenber.vue?vue&type=script&lang=js"
import style0 from "./Mymenber.vue?vue&type=style&index=0&id=523e1428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e1428",
  null
  
)

export default component.exports